import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { VendorService } from '../shared/vendor.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';
import { ProgressBarService } from '../shared/progress-bar.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-agreement-details',
  templateUrl: './agreement-details.component.html',
  styleUrls: ['./agreement-details.component.css', '../shared/css/common.css']
})
export class AgreementDetailsComponent implements OnInit, OnDestroy {


  @Input()
  showCaptcha: boolean | undefined;
  captcha: string;                              // empty = not yet proven to be a human, anything else = human
  email: string;
  formdata: any;
  payorkey: number;
  orglist: any = [];
  referralTypeList: any = [];
  referralInvolvedTypeList: any = [];
  sitekey: string;
  profileMasterTypeKey: any;
  subjecyTypeId: any;
  uploadsCompleted: boolean = false;
  IsUploadAttatchment: boolean = false;
  uploadFiles: string[] = [];
  primaryColor?: string = "";
  leadData: any;
  suspectFromPreview: string = '';
  suspectToPreview:   string = '';
  instructionText: string = '';
  
  userFormData: any;
  referralFormData: any;

  private uploadEndDataSub!: Subscription;
  private uploadFileDataSub!: Subscription;
  involvedPartyControl: any;
  referalFormData: any;
  additionalFormData: any;
  externalReferalFormData: any;
  primaryInvolvedPartyControls: any;
  additionalInvolvedPartyList: any = [];
  questionsFormData: any;
  questionsFormDataJson = [];
  submitClicked: boolean = false;

  constructor(
    private agreementFormBuilder: FormBuilder,
    private router: Router,
    private vendorService: VendorService,
    private cdref: ChangeDetectorRef,
    private datePipe: DatePipe,
    private modalService: NgbModal,
    private progressBarService: ProgressBarService,
    private spinner: NgxSpinnerService
  ) {
    this.captcha = '';
    this.email = 'Secret@email.com';
    this.formdata = this.vendorService.getSessionData();
    this.agreementFormData = this.formdata.agreementDetails;
    this.payorkey = parseInt(sessionStorage.getItem("payorkey") ?? "0");
    this.sitekey = environment.capchaSiteKey;

  }

  ngOnInit(): void {
    this.vendorService.getLeadHeaders(this.payorkey).subscribe((result)=>{
      let instructionText =  result.Instruction;
      instructionText = instructionText.replace('<img ','<img title="Header" ')
      this.instructionText = instructionText;
    });
    
    this.vendorService.getInvolvedPartiesLookup(this.payorkey).subscribe((result) => {
      this.referralInvolvedTypeList = result.map(x => { return { "value": x.Id, "key": x.Title } });
      let selectedpartyId = this.formdata.witnessDetails.controls.find((x: { name: string; }) => x.name == "involvedType").value;
      let selectedparty = result.find(x => x.Id == selectedpartyId);
      if (selectedparty) {
        this.profileMasterTypeKey = selectedparty.ProfileMasterTypeKey;
        this.subjecyTypeId = selectedparty.SubjectTypeKey;
      }
    })

    this.vendorService.getReferringSourcesLookup(this.payorkey).subscribe((result) => {
      this.orglist = result.map(x => { return { "value": x.Id, "key": x.Title } });
    })

    this.vendorService.getReferralTypesLookup(this.payorkey).subscribe((result) => {
      this.referralTypeList = result.map(x => { return { "value": x.Id, "key": x.Title } });
    })

    this.vendorService.getRequiredFields(this.payorkey).subscribe((result) => {
      this.IsUploadAttatchment = result.IsUploadAttatchment;
    });

    this.uploadEndDataSub = this.vendorService
      .getUploadEndData()
      .subscribe((data) => {
        if (data) {
            this.leadData.InternalLeadItem.UploadFileNames = this.vendorService.uploadFiles;
            let isReferralEmailSent = window.localStorage.getItem("SendEmailReferral");
            if(isReferralEmailSent == null) {
              this.sendReferralEmail(this.leadData);
            }
        }
      });
      
    this.uploadFileDataSub = this.vendorService.getUploadFileData().subscribe((result) => {
      if(result != null && result.length > 0) {
        this.vendorService.uploadFiles = [];
        result.forEach((item: any)=> {
          this.vendorService.uploadFiles.push(item.fileName);
        });
      }
      else {
        this.vendorService.uploadFiles = [];
      }
    });

      this.uploadFiles = this.vendorService.uploadFiles;
    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);

    //submit preview data
    
    this.userFormData = this.formdata.userDetails;
    this.referralFormData = this.formdata.witnessDetails;
    this.involvedPartyControl = this.formdata.witnessDetails.controls.slice(1, 2);
    this.externalReferalFormData = this.formdata.extenalReferall.controls.slice(0,1);
    this.additionalFormData = this.formdata.extenalReferall.controls.slice(1,3);
    this.primaryInvolvedPartyControls = this.formdata.involvedParties.data[0].formControlDetails.controls;
    this.formdata.involvedParties.data.forEach((item: any) => {
      if(!item.isPrimary) {
        let additionalInvolvedParty = {
          "controls": [
            {
              "name": "additionalInvolvedType",
              "label": "Additional Subject, Suspect or Involved Party Type",
              "value": item.subjectType,
              "type": "text"
            },
            {
              "name": "isAnotherExternalInvolvedParty",
              "label": "Is this involved party an external referring party or witness?",
              "value": item.isExternalReferal ? 'Yes' : 'No',
              "type": "select",
              "options": [
                  {
                      "key": "Yes",
                      "value": "Yes"
                  },
                  {
                    "key": "No",
                    "value": "No"
                  }
                ],
              "validators": {
                "required": true
              }
            },
            {
              "name": "externalReferalReport",
              "label": "How did this witness/external referring party report this?",
              "value": item.externalReferalReport,
              "type": "textarea",
              "options": {
                "showCount": false,
                "count": 0
              },
              "validators": {
                "required": true
              }
            },
            {
              "name": "externalReferalAddInfo",
              "label": "Any Additonal Information regarding the witness or external referring party?",
              "value": item.externalReferalAddInfo,
              "type": "textarea",
              "optional": true,
              "options": {
                "showCount": false,
                "count": 0
              },
              "validators": {
              }
            }
          ],
          "formControlDetails": item.formControlDetails
        }

        let involvedPartyControlsValue = {
          involvedPartyControl : additionalInvolvedParty.controls.slice(0, 1),
          externalReferalFormData : additionalInvolvedParty.controls.slice(1,2),
          additionalFormData : additionalInvolvedParty.controls.slice(2,4),
          involvedPartyControlDetails : additionalInvolvedParty.formControlDetails.controls
        }
        this.additionalInvolvedPartyList.push(involvedPartyControlsValue);
      }
    });
    
    
    if(this.formdata.questionsDetails && this.formdata.questionsDetails.controls){
      this.questionsFormData = { controls : []};
      this.questionsFormData.controls = this.formdata.questionsDetails.controls;
      this.questionsFormDataJson = [];
    }else{
      this.questionsFormDataJson = this.formdata.questionsDetails;
    }

    this.vendorService.getLeadQuestion(this.payorkey).subscribe((result)=>{
      let keys = Object.keys(result);
      if(!Array.isArray(this.questionsFormDataJson) || ( Array.isArray(this.formdata.questionsDetails) && this.formdata.questionsDetails.length == 0)) {     
        this.questionsFormData = { controls : []};
        let Qno = 0;
        for(let i=1;i<=50;i++){
          let active= keys.find(x => x.toLowerCase() == ('IsQuestion'+i+'Active').toLowerCase());
          let displayunknown = keys.find(x => x.toLowerCase() == ('IsQuestion'+i+'DisplayUnknown').toLowerCase());
          let required = keys.find(x => x.toLowerCase() == ('IsQuestion'+i+'DisplayText').toLowerCase());       
  
          if(active && result[active]) {
            Qno++;
            let label = ((result['Question' + i]).replace(/<p>/g, '<span>').replace(/<\/p>/g, '</span><br/>'))+'##end';
            let isRequired =(required && result[required]);
            if(isRequired)
            {
              label = label.replace(/<br\/>##end/g, '<span class="dynRequired">&nbsp;(Required)</span>')
              label = label.replace(/##end/g, '<span class="dynRequired">&nbsp;(Required)</span>')
            }
            else{
              label = label.replace(/##end/g, '')
            }
            if(displayunknown && result[displayunknown] == "1") {
              this.questionsFormData.controls.push({
                "name": "questiondDrDown" + i,
                "label": label,
                "value": "",
                "type": "select",
                "options": [
                  {
                    "key": "Yes",
                    "value": "Yes"
                  },
                  {
                    "key": "No",
                    "value": "No"
                  },
                  {
                    "key": "Unknown",
                    "value": "Unknown"
                  }
                  ,
                  {
                    "key": "Not Applicable",
                    "value": "Not Applicable"
                  }
                ],
                "validators": {
                  "required": isRequired,
                  "maxLength": 200
                },
                placeholder: '',
                required: false
              });
            }    
            else if(displayunknown && result[displayunknown] == "2") {
            this.questionsFormData.controls.push({
              "name": "questionTxt" + i,
              "label": label,
              "value": "",
              "type": "textarea",

              "options": {
                "showCount": true,
                "count": 0
              },
              "validators": {
                "required": isRequired,
                "maxLength": 2000
              },
              placeholder: '',
              required: false
            });  
          }        
          }
        }
      
    }
    });

    setTimeout(() => {
      this.progressBarService.sendData(true);
    });
  }

  ngOnDestroy(): void {
    if (this.uploadEndDataSub) {
      this.uploadEndDataSub.unsubscribe();
    }

    if (this.uploadFileDataSub) {
      this.uploadFileDataSub.unsubscribe();
    }
  }

  resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
    console.log('resolved captcha with response: ' + this.captcha);
  }

  agreementForm = this.agreementFormBuilder.group({});
  agreementFormData: any;

  createLocalDate(date?: any): Date | null {
    if (!date) return null;
    if (date instanceof Date) {
      return isNaN(date.getTime()) ? null : date;
    }
    if (typeof date !== 'string') return null;

    const parts = date.split('/');
    if (parts.length !== 3) return null;

    const month = parseInt(parts[0], 10) - 1;
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    if ([month, day, year].some(n => Number.isNaN(n))) return null;
    const d = new Date(year, month, day, 0, 0, 0);
    if (
      d.getFullYear() !== year ||
      d.getMonth() !== month ||
      d.getDate() !== day
    ) {
      return null;
    }

    return d;
  }

  dateOfBirth?:any;
  
  getLocalDate(date?: any): string | null {
    if (!date) return null;
    let d: Date | null = date instanceof Date ? date : new Date(date.trim());
    if (isNaN(d.getTime())) return null;
    return d.toISOString();
  }

  private toBrowserLocalDateTimeWithOffset(value: any): string | null {
    if (!value) return null;
    let d: Date | null = value instanceof Date ? value : new Date(value.trim());
    if (isNaN(d.getTime())) return null;
    const now = new Date();
    d.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), 0);
    return this.toLocalIsoWithOffset(d);
  }

  private buildDateTimes(value: any, submitNow: Date): { localWithOffset: string | null; utcIso: string | null } {
    if (!value) return { localWithOffset: null, utcIso: null };

    let d: Date | null = value instanceof Date ? new Date(value.getTime()) : new Date(value.trim());
    if (isNaN(d.getTime())) return { localWithOffset: null, utcIso: null };

    const isMidnight = d.getHours() === 0 && d.getMinutes() === 0 && d.getSeconds() === 0 && d.getMilliseconds() === 0;
    if (isMidnight) {
      d.setHours(submitNow.getHours(), submitNow.getMinutes(), submitNow.getSeconds(), 0);
    }

    return {
      localWithOffset: this.toLocalIsoWithOffset(d),
      utcIso: d.toISOString()
    };
  }

  private formatAsLocalNoOffsetNoT(value: string | null): string | null {
    if (!value) return null;
    const d = new Date(value);
    if (isNaN(d.getTime())) return null;
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
           `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.000`;
  }

    private toLocalIsoWithOffset(d: Date): string {
      d.setMilliseconds(0);
      const pad = (n: number) => String(n).padStart(2, '0');
      const offMinutes = -d.getTimezoneOffset();
      const sign = offMinutes >= 0 ? '+' : '-';
      const abs = Math.abs(offMinutes);
      const hh = pad(Math.floor(abs / 60));
      const mm = pad(abs % 60);
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T` +
            `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}` +
            `${sign}${hh}:${mm}`;
  }

  private getUtcNoOffsetString(localIsoWithOffset: string | null): string | null {
    if (!localIsoWithOffset) return null;
    const d = new Date(localIsoWithOffset);
    if (isNaN(d.getTime())) return null;
    const pad = (n: number) => String(n).padStart(2, '0');

    return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ` +
          `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}.000`;
  }

  getUsersTimeZone() {
        var timezoneMapping: { [key: string]: string } = {
            'Asia/Calcutta': 'India Standard Time',
            'America/New_York': 'US Eastern Standard Time',
            'America/Chicago': 'Central Standard Time',
            'America/Los_Angeles': 'Pacific Standard Time',
            'America/Denver': 'Mountain Standard Time',
            'America/Anchorage': 'Alaskan Standard Time',
            'Pacific/Honolulu': 'Hawaiian Standard Time',
            'America/Tijuana': 'Pacific Standard Time',
            'America/Phoenix': 'Mountain Standard Time'
        }
        var zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return timezoneMapping[zone] || 'Central Standard Time';
    }

  agreementDetailsSubmit() {
    
    let userDetailsFormValid = window.sessionStorage.getItem("UserDetailsFormValid") != null;
    let referralFormValid = window.sessionStorage.getItem("ReferralFormValid") != null;
    let involvedPartyFormValid = window.sessionStorage.getItem("InvolvedPartyFormValid") != null;
    let additionalInvolvedPartyFormValid = window.sessionStorage.getItem("AdditionalInvolvedPartyFormValid") != null;
    let questionsFormValid = window.sessionStorage.getItem("QuestionsFormValid") != null;

    if(userDetailsFormValid &&
      referralFormValid &&
      involvedPartyFormValid &&
      additionalInvolvedPartyFormValid &&
      questionsFormValid
    ) {
      this.submitClicked = true;
      this.formdata = this.vendorService.getSessionData();
      this.formdata.agreementDetails = this.agreementFormData;

      this.dateOfBirth = this.dateOfBirth == null ? null : this.datePipe.transform(this.createLocalDate(this.datePipe.transform(this.dateOfBirth, "MM/dd/yyyy")));
      const det = this.formdata.witnessDetails.controls.find((x: any) => x.name == "originalDetectionDt")?.value;
      const start = this.formdata.witnessDetails.controls.find((x: any) => x.name == "incidentStartDt")?.value;
      const end = this.formdata.witnessDetails.controls.find((x: any) => x.name == "incidentEndDt")?.value;
      const suspectStart = this.formdata.witnessDetails.controls.find((x: any) => x.name == "incidentStartDt")?.value;
      const suspectEnd = this.formdata.witnessDetails.controls.find((x: any) => x.name == "incidentEndDt")?.value;
      const submitNow = new Date();
      const detDt       = this.buildDateTimes(det, submitNow);
      const startDt     = this.buildDateTimes(start, submitNow);
      const endDt       = this.buildDateTimes(end, submitNow);
      const suspectFromDt = this.buildDateTimes(suspectStart, submitNow);
      const suspectToDt   = this.buildDateTimes(suspectEnd, submitNow);
      this.suspectFromPreview = this.formatAsLocalNoOffsetNoT(suspectFromDt.localWithOffset) || '�';
      this.suspectToPreview   = this.formatAsLocalNoOffsetNoT(suspectToDt.localWithOffset)   || '�';
      const participantDobRaw = this.formdata.participantDetails.controls.find((x: { name: any }) => x.name == "paDOB")?.value;
      const participantDobFormatted = participantDobRaw == null ? null : this.datePipe.transform( this.createLocalDate(this.datePipe.transform(participantDobRaw, 'MM/dd/yyyy')), 'MMM d yyyy');
      var data = {
        
        //userDetails
        FirstName: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "firstName")?.value,
        LastName: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "lastName")?.value,
        OrganizationId: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "orgName")?.value,
        OrganizationName: this.orglist.find((xy: { value: any; }) => xy.value == this.formdata.userDetails.controls.find((xy: any) => xy.name == "orgName")?.value)?.key,
        Relationship: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "title")?.value,
        Title: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "title")?.value,
        Phone: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "phone")?.value,
        Email: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "email")?.value,
        Address1: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "address1")?.value,
        Address2: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "address2")?.value,
        City: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "city")?.value,
        State: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "state")?.value,
        ZipCode: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "zip")?.value,

        //referal
        LeadReasons: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "referalType")?.value,
        ReferalType: this.referralTypeList.find((xz: { value: any; }) => xz.value == this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "referalType").value)?.key,
        ReferalTypeId: this.referralTypeList.find((xz: { value: any; }) => xz.value == this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "referalType").value)?.value,
        ReferalInvolvedType: this.referralInvolvedTypeList.find((xw: { value: any; }) => xw.value == this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "involvedType").value)?.key,
        InvolvedPartyTypeId: this.formdata.witnessDetails.controls.find((x: { name: string; }) => x.name == "involvedType").value,
        ReferalTrackingNumber: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "trackingNumber")?.value,
        AlternateId: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "trackingNumber")?.value,
        ReferalDetected: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "detected")?.value,
        ReferalEstimatedAmount: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "estimatedAmount")?.value,
        ReferalOriginalDetectionDt: this.getUtcNoOffsetString(detDt.localWithOffset),
        ReferalIncidentStartDt:     this.getUtcNoOffsetString(startDt.localWithOffset),
        ReferalIncidentEndDt:       this.getUtcNoOffsetString(endDt.localWithOffset),
        SuspectActivityFrom:        this.getUtcNoOffsetString(suspectFromDt.localWithOffset),
        SuspectActivityTo:          this.getUtcNoOffsetString(suspectToDt.localWithOffset),
        ReferalState: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "state")?.value,
        ReferalCounty: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "county")?.value,
        ReferralSummary: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "referralSummary")?.value,
        associatedLeadReasonId: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "associatedLeadReasonId")?.value,

        //witness
        WitnessExternalReferal: this.formdata.extenalReferall.controls.find((x: { name: any; }) => x.name == "isExternalReferal")?.value,
        
        //InvolvedParties
        InvolvedParties: this.constructInvolvedPartiesObj(),

        //Question
        QuestionList: this.formdata.questionsDetails.controls,

        FCReferralJson: JSON.stringify(this.formdata),
        TimeZoneName: this.getUsersTimeZone(),

        Description: this.formdata.summaryDetails.controls[0].value,
        LeadTypeId: this.subjecyTypeId,

        //Upload files
        UploadFileNames: this.uploadFiles

      }
      this.vendorService.createLead(this.payorkey, data).subscribe((result) => {
        if (result.IsSuccess) {
          this.leadData = result;
          if (!this.IsUploadAttatchment) {
            this.sendReferralEmail(result);
          }
          else {
            this.vendorService.sendUploadStartData(result);
          }
        } else {
          sessionStorage.removeItem("activeformdata");
          this.router.navigateByUrl("/" + (sessionStorage.getItem("securityCode") ?? ""));
          this.progressBarService.sendData(true);
        }

      }, error => { });
    }
  }

  sendReferralEmail(result: any) {
    window.localStorage.setItem("SendEmailReferral", "true");
    var param = {
        lead: result.InternalLeadItem,
        payorkey: this.payorkey,
        leadid: result.LeadId,
        leadKeyForResult: result.LeadKey,
        caseActivityKeyForResult: result.CaseActivityKey,
    }
    this.vendorService.sendReferralEmail(param).subscribe((res) => {
      this.spinner.hide('file-upload');
      this.router.navigate(['final']);
      this.progressBarService.sendData(true);
      window.sessionStorage.removeItem("UserDetailsFormValid");
      window.sessionStorage.removeItem("ReferralFormValid");
      window.sessionStorage.removeItem("InvolvedPartyFormValid");
      window.sessionStorage.removeItem("AdditionalInvolvedPartyFormValid");
      window.sessionStorage.removeItem("QuestionsFormValid");
    });
  }

  constructInvolvedPartiesObj(): any {
    let involvedParties: any = [];
    if(this.formdata.involvedParties  != null && this.formdata.involvedParties.data != null) {
      this.formdata.involvedParties.data.forEach((item: any) => {
        
        let formControlDetails = item.formControlDetails;        
        let sourceCode = "";
        let namePrefix = "";
        let firstName = "";
        let middleName = "";
        let lastName = "";
        let nameSuffix = "";
        let designation = "";
        let ssn = "";
        let licenceNumber = "";
        let manualSubjectID = "";
        let npi = "";
        let tin = "";
        let medicaidId = "";
        let medicareId = "";
        let otherId = "";
        let providerType = "";
        let ProviderSpecialty = "";
        let taxonomyId = "";
        let other = "";
        let streetAddress1 = "";
        let streetAddress2 = "";
        let city = "";
        let state = "";
        let county = "";
        let zip = "";
        let country = "";
        let phone = "";
        let secondaryPhone = "";
        let fax = "";
        let email = "";
        let gender = "";
        let plan = "";
        let program = "";
        let lob = "";
        let group = "";
        let contactNamePrefix = "";
        let contactFirstName = "";
        let contactMiddleName = "";
        let contactLastName = "";
        let contactDesignation = "";
        let associatedOrganizationName = "";

        switch (item.profileMasterTypeKey) {
          case 1:
            sourceCode = formControlDetails.controls.find((x: { name: any; }) => x.name == "pOrgName").value;
            namePrefix = formControlDetails.controls.find((x: { name: any; }) => x.name == "pNamePrefix").value;
            firstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "pFirstName").value;
            middleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "pMiddleName").value;
            lastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "pLastName").value;
            nameSuffix = formControlDetails.controls.find((x: { name: any; }) => x.name == "pNameSuffix").value;
            designation = formControlDetails.controls.find((x: { name: any; }) => x.name == "pDesignation").value;
            this.dateOfBirth = formControlDetails.controls.find((x: { name: any; }) => x.name == "pDateOfBirth").value;
            ssn = formControlDetails.controls.find((x: { name: any; }) => x.name == "pSsn").value;
            licenceNumber = formControlDetails.controls.find((x: { name: any; }) => x.name == "pLicenseNo").value;
            manualSubjectID = formControlDetails.controls.find((x: { name: any; }) => x.name == "pProviderID").value;
            npi = formControlDetails.controls.find((x: { name: any; }) => x.name == "pNPInumber").value;
            tin = formControlDetails.controls.find((x: { name: any; }) => x.name == "pTIN").value;
            medicaidId = formControlDetails.controls.find((x: { name: any; }) => x.name == "pMedicaidId").value;
            medicareId = formControlDetails.controls.find((x: { name: any; }) => x.name == "pMedicareId").value;
            otherId = formControlDetails.controls.find((x: { name: any; }) => x.name == "pOtherId").value;
            providerType = formControlDetails.controls.find((x: { name: any; }) => x.name == "pType").value;
            ProviderSpecialty = formControlDetails.controls.find((x: { name: any; }) => x.name == "pSpecialty").value;
            taxonomyId = formControlDetails.controls.find((x: { name: any; }) => x.name == "pTaxonomy").value;
            other = formControlDetails.controls.find((x: { name: any; }) => x.name == "pOther").value;
            streetAddress1 = formControlDetails.controls.find((x: { name: any; }) => x.name == "pStreetAddress1").value;
            streetAddress2 = formControlDetails.controls.find((x: { name: any; }) => x.name == "pStreetAddress2").value;
            city = formControlDetails.controls.find((x: { name: any; }) => x.name == "pCity").value;
            state = formControlDetails.controls.find((x: { name: any; }) => x.name == "pState").value;
            county = formControlDetails.controls.find((x: { name: any; }) => x.name == "pCounty").value;
            zip = formControlDetails.controls.find((x: { name: any; }) => x.name == "pZip").value;
            country = formControlDetails.controls.find((x: { name: any; }) => x.name == "pCountry").value;
            phone = formControlDetails.controls.find((x: { name: any; }) => x.name == "pPhone").value;
            fax = formControlDetails.controls.find((x: { name: any; }) => x.name == "pFax").value;
            email = formControlDetails.controls.find((x: { name: any; }) => x.name == "pEmail").value;
            break;
          case 2:
            namePrefix = formControlDetails.controls.find((x: { name: any; }) => x.name == "mNamePrefix").value;
            firstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "mFirstName").value;
            middleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "mMiddleName").value;
            lastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "mLastName").value;
            nameSuffix = formControlDetails.controls.find((x: { name: any; }) => x.name == "mNameSuffix").value;
            this.dateOfBirth = formControlDetails.controls.find((x: { name: any; }) => x.name == "mDateOfBirth").value;
            gender = formControlDetails.controls.find((x: { name: any; }) => x.name == "mGender").value;
            other = formControlDetails.controls.find((x: { name: any; }) => x.name == "mOther").value;
            manualSubjectID = formControlDetails.controls.find((x: { name: any; }) => x.name == "mID").value;
            ssn = formControlDetails.controls.find((x: { name: any; }) => x.name == "mSSN").value;
            medicaidId = formControlDetails.controls.find((x: { name: any; }) => x.name == "mMedicaidId").value;
            medicareId = formControlDetails.controls.find((x: { name: any; }) => x.name == "mMedicareId").value;
            otherId = formControlDetails.controls.find((x: { name: any; }) => x.name == "mOtherId").value;
            plan = formControlDetails.controls.find((x: { name: any; }) => x.name == "mPlan").value;
            program = formControlDetails.controls.find((x: { name: any; }) => x.name == "mProgram").value;
            lob = formControlDetails.controls.find((x: { name: any; }) => x.name == "mLOB").value;
            group = formControlDetails.controls.find((x: { name: any; }) => x.name == "mGroup").value;
            streetAddress1 = formControlDetails.controls.find((x: { name: any; }) => x.name == "mAddress1").value;
            streetAddress2 = formControlDetails.controls.find((x: { name: any; }) => x.name == "mAddress2").value;
            city = formControlDetails.controls.find((x: { name: any; }) => x.name == "mCity").value;
            state = formControlDetails.controls.find((x: { name: any; }) => x.name == "mState").value;
            county = formControlDetails.controls.find((x: { name: any; }) => x.name == "mCounty").value;
            zip = formControlDetails.controls.find((x: { name: any; }) => x.name == "mZip").value;
            phone = formControlDetails.controls.find((x: { name: any; }) => x.name == "mPrimaryPhone").value;
            secondaryPhone = formControlDetails.controls.find((x: { name: any; }) => x.name == "mSecondaryPhone").value;
            email = formControlDetails.controls.find((x: { name: any; }) => x.name == "mEmail").value;
            break;
          case 3:
            sourceCode = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepOrgName").value;
            namePrefix = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepNamePrefix").value;
            firstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepFirstName").value;
            middleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepMiddleName").value;
            lastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepLastName").value;
            nameSuffix = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepNameSuffix").value;
            designation = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepDesignation").value;
            this.dateOfBirth = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepDateOfBirth").value;
            ssn = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepSsn").value;
            licenceNumber = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepLicenseNo").value;
            otherId = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepOtherId").value;
            other = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepOther").value;
            phone = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepPrimaryPhone").value;
            secondaryPhone = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepSecondaryPhone").value;
            fax = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepFax").value;
            email = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepEmail").value;
            streetAddress1 = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepStreetAddress1").value;
            streetAddress2 = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepStreetAddress2").value;
            city = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepCity").value;
            state = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepState").value;
            county = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepCounty").value;
            zip = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepZip").value;
            country = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepCountry").value;
            break;
          case 4:
            sourceCode = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoOrgName").value;
            tin = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoTIN").value;
            licenceNumber = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoLicenseNo").value;
            other = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoOther").value;
            otherId = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoOtherId").value;
            contactNamePrefix = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoContactNamePrefix").value;
            contactFirstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoContactFirstName").value;
            contactMiddleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoContactMiddleName").value;
            contactLastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoContactLastName").value;
            contactDesignation = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoContactDesignation").value;
            streetAddress1 = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoStreetAddress1").value;
            streetAddress2 = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoStreetAddress2").value;
            city = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoCity").value;
            state = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoState").value;
            county = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoCounty").value;
            zip = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoZip").value;
            country = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoCountry").value;
            phone = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoPhone").value;
            fax = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoFax").value;
            email = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoEmail").value;
            break;
          case 5:
            namePrefix = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiNamePrefix").value;
            firstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiFirstName").value;
            middleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiMiddleName").value;
            lastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiLastName").value;
            nameSuffix = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiNameSuffix").value;
            designation = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiDesignation").value;
            this.dateOfBirth = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiDateOfBirth").value;
            ssn = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiSsn").value;
            otherId = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiOtherId").value;
            other = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiOther").value;
            streetAddress1 = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiStreetAddress1").value;
            streetAddress2 = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiStreetAddress2").value;
            city = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiCity").value;
            state = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiState").value;
            county = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiCounty").value;
            zip = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiZip").value;
            country = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiCountry").value;
            phone = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiPrimaryPhone").value;
            secondaryPhone = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiSecondaryPhone").value;
            email = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiEmail").value;
            associatedOrganizationName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiAssociatedOrg").value;
            break;
        }

        let involvedPartyControls = {
          
          ProfileMasterTypeKey: item.profileMasterTypeKey,
          IsPrimary: item.isPrimary,
          SubjectType: item.subjectType,
          SubjectTypeKey: item.subjectTypeKey,
          IsExternalReferal: item.isExternalReferal,
          ExternalReferalReport: item.externalReferalReport,
          ExternalReferalAddInfo: item.externalReferalAddInfo,
          SubjectOrganizationName: sourceCode,
          SubjectNamePrefix: namePrefix,
          SubjectFirstName: firstName,
          SubjectMiddleName: middleName,
          SubjectLastName: lastName,
          SubjectNameSuffix: nameSuffix,
          SubjectDesignation: designation,
          SubjectDateOfBirth: this.dateOfBirth,
          SubjectSsn: ssn,
          SubjectLicenceNumber: licenceNumber,
          SubjectManualSubjectId: manualSubjectID,
          SubjectNpi: npi,
          SubjectTin: tin,
          SubjectMedicaidId: medicaidId,
          SubjectMedicareId: medicareId,
          SubjectOtherId: otherId,
          SubjectProviderType: providerType,
          SubjectProviderSpecialty: ProviderSpecialty,
          SubjectTaxonomyId: taxonomyId,
          SubjectOther: other,
          SubjectStreetAddress1: streetAddress1,
          SubjectStreetAddress2: streetAddress2,
          SubjectCity: city,
          SubjectState: state,
          SubjectCounty: county,
          SubjectZip: zip,
          SubjectCountry: country,
          SubjectPhone: phone,
          SubjectSecondaryPhone: secondaryPhone,
          SubjectFax: fax,
          SubjectEmail: email,
          SubjectGender: gender,
          SubjectPlan: plan,
          SubjectProgram: program,
          SubjectLob: lob,
          SubjectGroup: group,
          SubjectContactNamePrefix: contactNamePrefix,
          SubjectContactFirstName: contactFirstName,
          SubjectContactMiddleName: contactMiddleName,
          SubjectContactLastName: contactLastName,
          SubjectContactDesignation: contactDesignation,
          SubjectAssociatedOrganizationName: associatedOrganizationName
        }

        involvedParties.push(involvedPartyControls);
      });
    }


    return involvedParties;
  }

  back() {
    this.vendorService.updateData(this.formdata);
    this.router.navigate(['questions']);
    setTimeout(() => {
      this.progressBarService.sendData(true);
    });
  }

  captchaEvent(captcha: string) {
    this.captcha = captcha;
  }


  openInstruction() {
    const result  = this.modalService.open(InstructionsComponent, {size: 'lg',  ariaLabelledBy: 'Instructions'});
    result.componentInstance.name = this.instructionText;
  }
}
